import React from 'react';
import CloseIcon from 'react-icons/lib/md/close';

import './infobox.styl';

const Infobox = props => {
  const onClose = () => {
    props.handler();
  }

  return (
    props.isActive ? (<div className="ifdw-infobox">
      <div className="ifdw-infobox--close" onClick={onClose}><CloseIcon /></div>
          {props.component}
    </div>) : null
  )
};

export default Infobox;



/** WEBPACK FOOTER **
 ** ./src/components/Infobox/index.js
 **/